import apiClient from '../axiosInstance';

import { postLoginAction } from '../sagas/login/loginSaga';
import { API_BASE_ADDRESS } from '../api';

// APIの住所を設定します。

const loginServices = (action: postLoginAction): any => {
  let data = {};
  if (action.loginClass === 0) {
    data = {
      member_id: action.memberShip,
      mobile_number: action.mobileNumber,
      birthday: action.birthday,
      login_class: action.loginClass,
    };
  } else if (action.loginClass === 1) {
    data = {
      login_class: action.loginClass,
      mail_address: action.mail_address,
      password: action.password,
    };
  } else if (action.loginClass === 2) {
    data = {
      login_class: action.loginClass,
      jwt_token: action.jwt_token,
    };
  } else {
    data = {};
  }

  return {
    postLogin: () => apiClient.post(`${API_BASE_ADDRESS}/mypage/login`, data),
  };
};

export default loginServices;
